import React from "react";
import { motion } from "framer-motion";
import MaskedLines from "@/components/MaskedLines";
import { HERO } from "@/constants/testIds";

export default function Hero() {
    return (
        <section
            id="home"
            data-testid={HERO.section}
            className="relative pt-24 md:pt-28 lg:pt-32"
        >
            {/* Headline + subheading — sized to sit above the fold on desktop */}
            <div className="mx-auto max-w-[1800px] px-6 md:px-12 lg:px-20 pb-20 md:pb-28">
                <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
                    <div className="col-span-12 lg:col-span-8">
                        <MaskedLines
                            as="h1"
                            testid={HERO.headline}
                            className="font-serif-editorial text-[#1B1B1B] text-[13vw] md:text-[10vw] lg:text-[8.4vw] leading-[0.94] tracking-[-0.025em]"
                            lineClassName="pb-1"
                            stagger={0.13}
                            duration={1.1}
                            lines={[
                                "Building brands",
                                <>
                                    that{" "}
                                    <em className="italic text-[#A8844F]">
                                        outlast
                                    </em>
                                </>,
                                "trends.",
                            ]}
                        />
                    </div>

                    {/* Subheading + CTAs — right column, aligned with the last hero line */}
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                            duration: 1,
                            delay: 1.0,
                            ease: [0.16, 1, 0.3, 1],
                        }}
                        className="col-span-12 lg:col-span-4 lg:pb-4"
                    >
                        <div className="flex items-start gap-5 mb-7">
                            <span className="eyebrow mt-2 text-[#1B1B1B]/70 shrink-0">
                                01 —
                            </span>
                            <p
                                data-testid={HERO.subheading}
                                className="font-sans-tight text-base md:text-lg lg:text-[19px] leading-[1.5] text-[#1B1B1B] max-w-md font-light"
                            >
                                Depmont is an independent creative company
                                helping founders and businesses build
                                identities, editorial systems and digital
                                experiences designed for long-term growth.
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4 pt-2">
                            <a
                                href="#work"
                                data-testid={HERO.ctaPrimary}
                                className="group inline-flex items-center gap-3 px-7 py-[14px] bg-[#1B1B1B] text-[#F6F3EC] font-sans-tight text-[12px] tracking-[0.2em] uppercase transition-colors duration-500 hover:bg-[#A8844F]"
                            >
                                View our work
                                <svg
                                    className="w-4 h-4 transition-transform duration-500 group-hover:translate-y-0.5"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.2"
                                >
                                    <path d="M8 1v14M2 9l6 6 6-6" />
                                </svg>
                            </a>
                            <a
                                href="mailto:contact@depmont.com"
                                data-testid={HERO.ctaSecondary}
                                className="inline-flex items-center gap-3 px-7 py-[14px] border border-[#1B1B1B] text-[#1B1B1B] font-sans-tight text-[12px] tracking-[0.2em] uppercase transition-colors duration-500 hover:bg-[#1B1B1B] hover:text-[#F6F3EC]"
                            >
                                Start a conversation
                            </a>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
